if ('analyticsEvent' in window === false) {
    window.analyticsEvent = function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        console.debug(new Date().toString(), "Dummy analyticsEvent(" + args.join(', ') + ")");
    };
}
if ('ga4Event' in window === false) {
    window.ga4Event = function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        console.debug(new Date().toString(), "Dummy ga4Event(" + args.join(', ') + ")");
    };
}
if ('audioEvent' in window === false) {
    window.audioEvent = function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        console.debug(new Date().toString(), "Dummy audioEvent(" + args.join(', ') + ")");
    };
}
